export enum CreditLineProvider {
    Default = 'default',
    Supplier = 'supplier',
}
